import { useCallback, useMemo } from 'react';

export const useJiraSelectorOnSelect = <T extends { id: string | number }>(selected: T[], onChange: (next: T[]) => void) =>
    useCallback((item: T) => {
        const toggle = selected.find(x => x.id === item.id);
        const next = toggle ? selected.filter(x => x.id !== item.id) : [...selected, item];
        onChange(next);
    }, [selected, onChange]);

export const useSelectedItemsIfApplicable = <T extends { id: string | number }>(data: T[], selection?: (string | number)[]) => {
    return useMemo(() => {
        if (!!data && !!selection) {
            const lookup = new Set(selection);

            return [
                data.map((item) => {
                    return {
                        ...item,
                        selected: lookup.has(item.id),
                    };
                }),
                'selected'
            ] as const;
        }
        else {
            return [data, null] as const;
        }

    }, [data, selection]);
};
